//////IN SITU///////
//Arabe Siria
import ISproj1_PORTADA from "../assets/images/projects/1 Arabe Siria/PORTADA.jpg";
import ISproj1_PLANTA from "../assets/images/projects/1 Arabe Siria/PLANTA.png";
import ISproj1_1 from "../assets/images/projects/1 Arabe Siria/1.jpg";
import ISproj1_2 from "../assets/images/projects/1 Arabe Siria/2.jpg";
import ISproj1_3 from "../assets/images/projects/1 Arabe Siria/3.jpg";
import ISproj1_4 from "../assets/images/projects/1 Arabe Siria/4.jpg";
import ISproj1_5 from "../assets/images/projects/1 Arabe Siria/5.jpg";
import ISproj1_6 from "../assets/images/projects/1 Arabe Siria/6.jpg";
import ISproj1_7 from "../assets/images/projects/1 Arabe Siria/7.jpg";
import ISproj1_8 from "../assets/images/projects/1 Arabe Siria/8.jpg";
import ISproj1_9 from "../assets/images/projects/1 Arabe Siria/9.jpg";
import ISproj1_10 from "../assets/images/projects/1 Arabe Siria/10.jpg";
import ISproj1_11 from "../assets/images/projects/1 Arabe Siria/11.jpg";
import ISproj1_12 from "../assets/images/projects/1 Arabe Siria/12.jpg";
import ISproj1_13 from "../assets/images/projects/1 Arabe Siria/13.jpg";

//MT de alvear
import ISproj2_PORTADA from "../assets/images/projects/2 mt de alvear/PORTADA.jpg";
import ISproj2_PLANTA from "../assets/images/projects/2 mt de alvear/PLANTA.png";
import ISproj2_1 from "../assets/images/projects/2 mt de alvear/1.jpg";
import ISproj2_2 from "../assets/images/projects/2 mt de alvear/2.jpg";
import ISproj2_3 from "../assets/images/projects/2 mt de alvear/3.jpg";
import ISproj2_4 from "../assets/images/projects/2 mt de alvear/4.jpg";
import ISproj2_5 from "../assets/images/projects/2 mt de alvear/5.jpg";
import ISproj2_6 from "../assets/images/projects/2 mt de alvear/6.jpg";
import ISproj2_7 from "../assets/images/projects/2 mt de alvear/7.jpg";
import ISproj2_8 from "../assets/images/projects/2 mt de alvear/8.jpg";
import ISproj2_9 from "../assets/images/projects/2 mt de alvear/9.JPG";
import ISproj2_10 from "../assets/images/projects/2 mt de alvear/10.jpg";
import ISproj2_11 from "../assets/images/projects/2 mt de alvear/11.jpg";
import ISproj2_12 from "../assets/images/projects/2 mt de alvear/12.jpg";
import ISproj2_13 from "../assets/images/projects/2 mt de alvear/13.jpg";

//Concurso
import ISproj3_PORTADA from "../assets/images/projects/3 concurso/PORTADA.jpg";
// import ISproj3_PLANTA from "../assets/images/projects/3 concurso/PLANTA.jpg";
import ISproj3_1 from "../assets/images/projects/3 concurso/1.jpg";
import ISproj3_2 from "../assets/images/projects/3 concurso/2.jpg";
// import ISproj3_3 from "../assets/images/projects/3 concurso/3.jpg";
import ISproj3_4 from "../assets/images/projects/3 concurso/4.jpg";
import ISproj3_5 from "../assets/images/projects/3 concurso/5.jpg";
import ISproj3_6 from "../assets/images/projects/3 concurso/6.jpg";
import ISproj3_7 from "../assets/images/projects/3 concurso/7.jpg";
import ISproj3_8 from "../assets/images/projects/3 concurso/8.jpg";
import ISproj3_9 from "../assets/images/projects/3 concurso/9.jpg";
import ISproj3_10 from "../assets/images/projects/3 concurso/10.jpg";
// import ISproj3_9 from "../assets/images/projects/3 concurso/9.jpg";

//Anchorena 6M
import ISproj4_PORTADA from "../assets/images/projects/4 anchorena 6M/PORTADA.JPG";
import ISproj4_PLANTA from "../assets/images/projects/4 anchorena 6M/PLANTA.png";
import ISproj4_1 from "../assets/images/projects/4 anchorena 6M/1.JPG";
import ISproj4_2 from "../assets/images/projects/4 anchorena 6M/2.JPG";
import ISproj4_3 from "../assets/images/projects/4 anchorena 6M/3.JPG";
import ISproj4_4 from "../assets/images/projects/4 anchorena 6M/4.JPG";
import ISproj4_5 from "../assets/images/projects/4 anchorena 6M/5.JPG";
import ISproj4_6 from "../assets/images/projects/4 anchorena 6M/6.JPG";
import ISproj4_7 from "../assets/images/projects/4 anchorena 6M/7.JPG";
import ISproj4_8 from "../assets/images/projects/4 anchorena 6M/8.JPG";
import ISproj4_9 from "../assets/images/projects/4 anchorena 6M/9.JPG";
import ISproj4_10 from "../assets/images/projects/4 anchorena 6M/10.JPG";

//////TABULA RASA///////
//UBA final de Grado

import TRproj1_PORTADA from "../assets/images/tabula/1 UBA final de Grado/PORTADA.JPG";
import TRproj1_PLANTA from "../assets/images/tabula/1 UBA final de Grado/PLANTA.jpg";
import TRproj1_1 from "../assets/images/tabula/1 UBA final de Grado/1.jpg";
import TRproj1_2 from "../assets/images/tabula/1 UBA final de Grado/2.jpg";
import TRproj1_3 from "../assets/images/tabula/1 UBA final de Grado/3.jpg";
import TRproj1_4 from "../assets/images/tabula/1 UBA final de Grado/4.jpg";
import TRproj1_5 from "../assets/images/tabula/1 UBA final de Grado/5.jpg";
import TRproj1_6 from "../assets/images/tabula/1 UBA final de Grado/6.jpg";
import TRproj1_7 from "../assets/images/tabula/1 UBA final de Grado/7.jpg";

//WS pabellón erizo

import TRproj2_PORTADA from "../assets/images/tabula/2 WS pabellón erizo/PORTADA.jpg";
import TRproj2_PLANTA from "../assets/images/tabula/2 WS pabellón erizo/PLANTA.jpg";
import TRproj2_1 from "../assets/images/tabula/2 WS pabellón erizo/1.jpg";
import TRproj2_2 from "../assets/images/tabula/2 WS pabellón erizo/2.jpg";
import TRproj2_3 from "../assets/images/tabula/2 WS pabellón erizo/3.jpg";
import TRproj2_4 from "../assets/images/tabula/2 WS pabellón erizo/4.jpg";
import TRproj2_5 from "../assets/images/tabula/2 WS pabellón erizo/5.jpg";
import TRproj2_6 from "../assets/images/tabula/2 WS pabellón erizo/6.jpg";
import TRproj2_7 from "../assets/images/tabula/2 WS pabellón erizo/7.jpg";
import TRproj2_8 from "../assets/images/tabula/2 WS pabellón erizo/8.jpg";
import TRproj2_9 from "../assets/images/tabula/2 WS pabellón erizo/9.jpg";
import TRproj2_10 from "../assets/images/tabula/2 WS pabellón erizo/10.jpg";

//UTDT Master materiales y tecnología

import TRproj3_PORTADA from "../assets/images/tabula/3 UTDT Master materiales y tecnología/PORTADA.JPG";
import TRproj3_PLANTA from "../assets/images/tabula/3 UTDT Master materiales y tecnología/PLANTA.jpg";
import TRproj3_1 from "../assets/images/tabula/3 UTDT Master materiales y tecnología/1.jpg";
import TRproj3_2 from "../assets/images/tabula/3 UTDT Master materiales y tecnología/2.jpg";
import TRproj3_3 from "../assets/images/tabula/3 UTDT Master materiales y tecnología/3.jpg";
import TRproj3_4 from "../assets/images/tabula/3 UTDT Master materiales y tecnología/4.jpg";
import TRproj3_5 from "../assets/images/tabula/3 UTDT Master materiales y tecnología/5.jpg";
import TRproj3_6 from "../assets/images/tabula/3 UTDT Master materiales y tecnología/6.jpg";
import TRproj3_7 from "../assets/images/tabula/3 UTDT Master materiales y tecnología/7.jpg";
import TRproj3_8 from "../assets/images/tabula/3 UTDT Master materiales y tecnología/8.jpg";

//IAAC Master emergent futures

import TRproj4_PORTADA from "../assets/images/tabula/4 IAAC Master emergent futures/PORTADA.jpg";
import TRproj4_PLANTA from "../assets/images/tabula/4 IAAC Master emergent futures/PLANTA.png";
import TRproj4_1 from "../assets/images/tabula/4 IAAC Master emergent futures/1.png";
import TRproj4_2 from "../assets/images/tabula/4 IAAC Master emergent futures/2.png";
import TRproj4_3 from "../assets/images/tabula/4 IAAC Master emergent futures/3.png";
import TRproj4_4 from "../assets/images/tabula/4 IAAC Master emergent futures/4.png";
import TRproj4_5 from "../assets/images/tabula/4 IAAC Master emergent futures/5.png";
import TRproj4_6 from "../assets/images/tabula/4 IAAC Master emergent futures/6.jpg";
import TRproj4_7 from "../assets/images/tabula/4 IAAC Master emergent futures/7.png";

const inSitu = [
  {
    title: "árabe siria",
    subtitle: "vivienda unifamiliar",
    tags: {
      tipo: "reforma",
      año: "2011",
      locación: "caba, ba. argentina",
      proyecto: "julia quiroga + estudio bluyin",
      superficie: "150m2",
    },
    portada: ISproj1_PORTADA,
    plano: ISproj1_PLANTA,
    img: [
      ISproj1_1,
      ISproj1_2,
      ISproj1_3,
      ISproj1_4,
      ISproj1_5,
      ISproj1_6,
      ISproj1_7,
      ISproj1_8,
      ISproj1_9,
      ISproj1_10,
      ISproj1_11,
      ISproj1_12,
      ISproj1_13,
    ],
  },
  {
    title: "mt de alvear",
    subtitle: "vivienda unifamiliar",
    tags: {
      tipo: "reforma",
      año: "2012",
      locación: "caba, ba. argentina",
      proyecto: "julia quiroga",
      superficie: "220m2",
    },
    portada: ISproj2_PORTADA,
    plano: ISproj2_PLANTA,
    img: [
      ISproj2_1,
      ISproj2_2,
      ISproj2_3,
      ISproj2_4,
      ISproj2_5,
      ISproj2_6,
      ISproj2_7,
      ISproj2_8,
      ISproj2_9,
      ISproj2_10,
      ISproj2_11,
      ISproj2_12,
      ISproj2_13,
    ],
  },
  {
    title: "concurso",
    subtitle: "concurso público nacional",
    tags: {
      tipo: "monumento conmemorativo a los libertadores de suramérica",
      año: "2014",
      locación: "mar del plata, ba. argentina",
      proyecto: "julia quiroga en colaboración con Lily Wicnudel",
      superficie: "3.75mts de alto x 10m2 de base",
    },
    texto:
      ".. Así es como preferimos rendir homenaje a nuestros héroes del pasado y del presente, unificando nuestra diversidad, tratando de convertir el monumento en una proyección hacia el futuro, hacia EL TIEMPO DE SURAMÉRICA.",
    portada: ISproj3_PORTADA,
    img: [
      ISproj3_1,
      ISproj3_2,
      // ISproj3_3,
      ISproj3_4,
      ISproj3_5,
      ISproj3_6,
      ISproj3_7,
      ISproj3_8,
      ISproj3_9,
      ISproj3_10,
    ],
  },
  {
    title: "anchorena 6M",
    subtitle: "vivienda unifamiliar",
    tags: {
      tipo: "reforma",
      año: "2017",
      locación: "caba, ba. argentina",
      proyecto: "julia quiroga",
      superficie: "60m2",
    },
    portada: ISproj4_PORTADA,
    plano: ISproj4_PLANTA,
    img: [
      ISproj4_1,
      ISproj4_2,
      ISproj4_3,
      ISproj4_4,
      ISproj4_5,
      ISproj4_6,
      ISproj4_7,
      ISproj4_8,
      ISproj4_9,
      ISproj4_10,
    ],
  },
];

const tabulaRasa = [
  {
    title: "universidad de buenos aires",
    subtitle: "Carrera de Grado - Proyecto Final",
    description:
      "Esta aproximación produce una estructura abierta que responde simultáneamente a condiciones interiores y exteriores y que permanece adaptable a una multiplicidad de formas de habitar.",
    portada: TRproj1_PORTADA,
    plano: TRproj1_PLANTA,
    img: [
      TRproj1_1,
      TRproj1_2,
      TRproj1_3,
      TRproj1_4,
      TRproj1_5,
      TRproj1_6,
      TRproj1_7,
    ],
  },
  {
    title: "FABLAB argentina",
    subtitle:
      "WORKSHOP PABELLÓN ALGORÍTMICO “Estructuras paramétricas de construcción rápida”",
    description:
      "Identificar, entender y aplicar los pasos para el proyecto, el diseño y la construcción de una estructura paramétrica realizada mediante técnicas de fabricación digital.",
    portada: TRproj2_PORTADA,
    plano: TRproj2_PLANTA,
    img: [
      TRproj2_1,
      TRproj2_2,
      TRproj2_3,
      TRproj2_4,
      TRproj2_5,
      TRproj2_6,
      TRproj2_7,
      TRproj2_8,
      TRproj2_9,
      TRproj2_10,
    ],
  },
  {
    title: "universidad torcuato di tella",
    subtitle: "Posgrado de Arquitectura y Tecnología",
    description:
      "Un espacio de formación, investigación y producción proyectual que explora nuevas posibilidades técnicas con el objetivo de desarrollar procedimientos, estados organizativos y materiales para una arquitectura por venir.",
    portada: TRproj3_PORTADA,
    plano: TRproj3_PLANTA,
    img: [
      TRproj3_1,
      TRproj3_2,
      TRproj3_3,
      TRproj3_4,
      TRproj3_5,
      TRproj3_6,
      TRproj3_7,
      TRproj3_8,
    ],
  },
  {
    title: "instituto de arquitectura avanzada",
    subtitle: "Master in Design for Emergent Futures",
    description:
      " is a new interface for the collection of data as images that aims to change the methodology of co-creation in participatory design for public spaces.",
    portada: TRproj4_PORTADA,
    plano: TRproj4_PLANTA,
    img: [
      TRproj4_1,
      TRproj4_2,
      TRproj4_3,
      TRproj4_4,
      TRproj4_5,
      TRproj4_6,
      TRproj4_7,
    ],
    web: "https://mdef.gitlab.io/2018/julia.quiroga/",
  },
];

const projectList = [inSitu, tabulaRasa];

export default projectList;
